import { AfterViewInit, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import * as moment from 'moment-timezone';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { PushToTalkService } from 'src/app/component/push-to-talk/push-to-talk-service/push-to-talk.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { sweetAlert } from 'src/app/utils/swal';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { StaffService } from '../../staffs/staff-service/staff.service';

@Component({
  selector: 'app-all-recordings',
  templateUrl: './all-recordings.component.html',
  styleUrls: ['./all-recordings.component.css']
})
export class AllRecordingsComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('messageTone', { static: true }) messageTone: ElementRef;
  @ViewChildren('audioPlayer') audioPlayers!: QueryList<ElementRef<HTMLAudioElement>>;
  driverSms = [];
  groupList = {};
  todayDate;
  user;
  viewers;
  preDriverList;
  preStaffList;
  constructor(
    private pushToTalk: PushToTalkService,
    private socketService: SocketService,
    private sharedDataService: SharedDataService,
    private driverService: DriversService,
    private staffService:StaffService
  ) { }


  ngOnInit() {
    this.getUser();
  }

  ngAfterViewInit() {
    if (!this.audioPlayers) {
      console.error('No audio players found');
      return;
    }

    // Add listeners for initial players
    this.addListenersToPlayers(this.audioPlayers);

    // Listen for updates to the QueryList
    this.audioPlayers.changes.subscribe((players: QueryList<ElementRef<HTMLAudioElement>>) => {

      // Remove listeners from old players
      this.removeListenersFromPlayers(this.audioPlayers);

      // Add listeners to updated players
      this.addListenersToPlayers(players);
    });
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.setUpDriverAlertSocketListener();
          this.getDriverList();
          this.getStaffList();
        }
      });
  }

  setUpDriverAlertSocketListener() {
    let isStaff = this.user && this.user.sId ? true : false;
    this.socketService.addListener(Events.PUSH_TO_TALK)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if (isStaff && data.type === 'cnew') {
            return; // ignore cmessage if received for the company.
          }

          this.driverSms.push(data.pushtotalkmessage);
          this.markAsReadMessage(data.pushtotalkmessage._id);
        } else {
          sweetAlert('Error', data.message, 'error', 'OK');

        }
      });

  }

  markAsReadMessage = (pushtotalkmessageId) => {
    this.pushToTalk.markAsReadMessage({ pushtotalkmessageId }).pipe(takeUntil(takeUntilDestroyed(this))).subscribe((data) => {
      if (data) {
        const filtertedSms = this.driverSms.find(item => item._id === data._id);
        if (filtertedSms) {
          filtertedSms.viewers.push(this.user._id);
        }
      }
    })
  };

  getGroupMessages() {
    const queryParams = {
      status: 'all',
      datetime: this.todayDate
    }

    this.pushToTalk.getAllPushToTalkMessages(queryParams).pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((data) => {
        this.driverSms = data.pushtotalkmessages;
        this.groupList = data.groups.reduce((obj, item) => (obj[item._id] = item, obj), {});
      })
  }

  onDateChange(event) {
    this.todayDate = event.toISOString();
    this.getGroupMessages();
  }


  handlePlay = (event: Event) => {
    const playerElement = event.target as HTMLAudioElement;
    const filtertedSms = this.driverSms.find(item => item._id === playerElement.id);
    if (!(filtertedSms && filtertedSms.sender_id !== this.user._id && filtertedSms.viewers.includes(this.user._id))) {
      this.markAsReadMessage(playerElement.id);
    }

  };

  handlePause = (event: Event) => {
    const playerElement = event.target as HTMLAudioElement;
  };

  handleEnded = (event: Event) => {
    const playerElement = event.target as HTMLAudioElement;
  };

  addListenersToPlayers(players: QueryList<ElementRef<HTMLAudioElement>>) {
    players.forEach((audioPlayer) => {
      const playerElement = audioPlayer.nativeElement;

      playerElement.addEventListener('play', this.handlePlay);
      playerElement.addEventListener('pause', this.handlePause);
      playerElement.addEventListener('ended', this.handleEnded);

    });
  }

  removeListenersFromPlayers(players: QueryList<ElementRef<HTMLAudioElement>>) {
    players.forEach((audioPlayer) => {
      const playerElement = audioPlayer.nativeElement;

      playerElement.removeEventListener('play', this.handlePlay);
      playerElement.removeEventListener('pause', this.handlePause);
      playerElement.removeEventListener('ended', this.handleEnded);

    });
  }
  getDriverList() {
    this.driverService
      .getDrivers(this.user._id, 'active')
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preDriverList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      });
  }

  getStaffList() {
    // let queryParams = {
    //   status: 'active'
    // };
    this.staffService
      .getStaffList()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }


  ngOnDestroy(): void {
    this.removeListenersFromPlayers(this.audioPlayers);
    this.socketService.removeListener(Events.PUSH_TO_TALK);
  }

  openViewerModal(payload: any) {
    if (payload)
      this.viewers = { viewer: payload.viewers, staff: this.preStaffList, driver: this.preDriverList, company: this.user }
  }
}
